import { render, staticRenderFns } from "./goodsChangeAdd.vue?vue&type=template&id=0dfc6997&scoped=true"
import script from "./goodsChangeAdd.vue?vue&type=script&lang=js"
export * from "./goodsChangeAdd.vue?vue&type=script&lang=js"
import style0 from "./goodsChangeAdd.vue?vue&type=style&index=0&id=0dfc6997&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfc6997",
  null
  
)

export default component.exports